function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "assets/badges/ic_gray_badge_pm",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("rect", {
  id: "bounds",
  x: 0,
  y: 0,
  width: 48,
  height: 28
}), React.createElement("rect", {
  id: "background",
  fill: "#F9F9F9",
  x: 0,
  y: 0,
  width: 48,
  height: 28,
  rx: 14
}), React.createElement("path", {
  fill: "#FB5607",
  d: "m12.44,15.88v5.26h-3.08V6.21h5.82c1.12,0,2.11.21,2.96.62s1.51.99,1.96,1.75c.46.76.69,1.62.69,2.58,0,1.46-.5,2.62-1.5,3.46s-2.39,1.27-4.16,1.27h-2.7Zm0-2.49h2.75c.81,0,1.43-.19,1.86-.57s.64-.93.64-1.64-.21-1.32-.64-1.77c-.43-.45-1.03-.68-1.79-.7h-2.82v4.69Z"
}), React.createElement("path", {
  fill: "#FB5607",
  d: "m26.93,6.21l3.83,10.83,3.81-10.83h4.04v14.93h-3.09v-4.08l.31-7.04-4.03,11.12h-2.11l-4.02-11.11.31,7.03v4.08h-3.08V6.21h4.02Z"
}));

var SvgIcGrayBadgePm = function SvgIcGrayBadgePm(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "48px",
    height: "28px",
    viewBox: "0 0 48 28",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcGrayBadgePm, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_gray_badge_pm.16488f8d.svg";
export { ForwardRef as ReactComponent };